import { render } from "./thong-tin-ca-nhan.vue?vue&type=template&id=27519a15&scoped=true"
import script from "./thong-tin-ca-nhan.vue?vue&type=script&lang=js"
export * from "./thong-tin-ca-nhan.vue?vue&type=script&lang=js"

import "./thong-tin-ca-nhan.vue?vue&type=style&index=0&id=27519a15&lang=scss&scoped=true"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27519a15"]])

export default __exports__